import _ from 'lodash';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from '../../../../global/cnr/reducers/reducerHelpers/dispatchProps';
import { convertHelpers } from '../../../../global/common/convert';
import { getCalStartDates } from '../../../../global/common/filtering';
import { createSportsHelpers } from './reducerHelpers/createSportsData';

const rts = {
  handleAmmend_level: 'handleAmmend_level',
  handleAmmend_match: 'handleAmmend_match',
  handleAmmend_matchLocation: 'handleAmmend_matchLocation',
  handleAmmend_matchTime: 'handleAmmend_matchTime',
  handleAmmend_playoffDateGroup: 'handleAmmend_playoffDateGroup',
  handleAmmend_playoffMatchInfo: 'handleAmmend_playoffMatchInfo',
  handleAmmend_playoffSeededTeams: 'handleAmmend_playoffSeededTeams',
  handleClear_playoffTeams: 'handleClear_playoffTeams',
  handleSelect_playoffDates: 'handleSelect_playoffDates',
  handleSelect_playoffTeam: 'handleSelect_playoffTeam',
  // handleSelect_playoffTeamRecord: 'handleSelect_playoffTeamRecord',
  handleSelectedTeams: 'handleSelectedTeams',
  handleSet_team_playoffGroup: 'handleSet_team_playoffGroup',
  handleSet_playoffInfo: 'handleSet_playoffInfo',
  handleSet_playoffLevelCount: 'handleSet_playoffLevelCount',
  handleSet_playoffLevelTeams: 'handleSet_playoffLevelTeams',
  handleShow_playoffMatchLocation: 'handleShow_playoffMatchLocation',
  handleShow_playoffMatchTime: 'handleShow_playoffMatchTime',
  handleUpdate_seededTeams: 'handleUpdate_seededTeams',
  ...grts,
}

export const sectionCountTypes = {
  checked: 'checked',
  qualifyCount: 'qualifyCount',
  sectionCount: 'sectionCount',
}

export const createScheduleTypes = {
  season: 'season',
  playoff: 'playoff',
}

export const seasonalUpdateSteps = {
  qualifyCount: 'qualifyCount',
  seasonAlignment: 'seasonAlignment',
  seasonDetails: 'seasonDetails',
  seasonSchedule: 'seasonSchedule',
  seasonSectionCount: 'seasonSectionCount',
  seasonSectionDates: 'seasonSectionDates',
  seasonSectionTeams: 'seasonSectionTeams',
  seasonTeams: 'seasonTeams',
  teams: 'teams',
  year: 'year',
}


/** 
 * @param {object} state 
 * @param {object} action 
 * @returns 
 */
export const createPlayoffReducer = (state, action) => {

  const {
    details_info,
    playoff_info,
    playoff_matchInfo,
    sportsSeason_data,
  } = state

  const { type, dispatch } = action

  const _playoffInfo = _.clone(playoff_info)
  const _playoff_matchInfo = _.clone(playoff_matchInfo)
  const { playoffTeams, playoffTeamCompares } = _playoffInfo ?? {}
  const { teams } = sportsSeason_data ?? {}

  switch (type) {

    case rts.handleAmmend_level:
      _playoffInfo.playoffLevel = action.playoffLevel
      return { ...state, playoff_info: _playoffInfo }

    case rts.handleSet_playoffInfo:

      const d = new Date()

      const msds = [
        new Date(d.getFullYear(), d.getMonth() - 1, 1),
        new Date(d.getFullYear(), d.getMonth(), 1),
        new Date(d.getFullYear(), d.getMonth() + 1, 1)
      ]

      if (action.playoff_info) {
        const { playoff_info, fk } = action
        const { playoffLevelTeams, playoffDates_selected } = playoff_info ?? {}

        let _monthStartDates;

        if (details_info && details_info.details && details_info.details.seasonStartDate) {
          const { monthStartDates } = details_info.details.seasonStartDate ? getCalStartDates([details_info.details.seasonStartDate], 4) : {}
          if (monthStartDates) {
            _monthStartDates = monthStartDates
          }
        }

        _playoffInfo.found = true

        if (playoffLevelTeams) {
          // createSportsHelpers.ammend_playoffSeedingMismatch(playoffLevelTeams)
          // createSportsHelpers.assign_recordsToTeams(playoffLevelTeams, _playoffInfo)
          const pdts = createSportsHelpers.ammend_playoffDatesNeeded(playoffLevelTeams)
          const pmcs = createSportsHelpers.ammend_playoffMatchCounts(playoffLevelTeams)

          _playoffInfo.playoffLevelTeams = playoffLevelTeams
          _playoffInfo.playoffDates_needed = pdts.playoffDates_needed
          _playoffInfo.playoffMatches_needed = pmcs
          _playoffInfo.playoffDates_ready = pdts.playoffDates_ready
          _playoffInfo.playoffDates_selected = pdts.playoffDates_selected
          _playoffInfo.plts = createSportsHelpers.getPlayoffLevelTeamz(_playoffInfo.playoffLevelTeams)

        }
        if (playoffDates_selected) { _playoffInfo.playoffDates_selected = playoffDates_selected }
        if (fk) { _playoffInfo.parentDataKey = fk }

        const _playoffInfoo = createSportsHelpers.ammend_currentPlayoffInfo(_playoffInfo)
        _playoffInfoo.monthStartDates = msds
        return { ...state, playoff_info: _playoffInfoo }
      } else {
        _playoffInfo.found = false
        _playoffInfo.monthStartDates = msds
        return { ...state, playoff_info: _playoffInfo }
      }

    case rts.handleAmmend_playoffDateGroup:
      const cpi1 = createSportsHelpers.ammend_currentPlayoffInfo(state.playoff_info, state.playoffGroupKey, action)
      return { ...state, playoff_info: cpi1 }

    case rts.handleSelect_playoffDates:
      const cpi2 = createSportsHelpers.ammend_currentPlayoffInfo(state.playoff_info, state.playoffGroupKey, action)
      return { ...state, playoff_info: cpi2 }

    case rts.handleAmmend_playoffMatchInfo:
      return {
        ...state,
        playoff_matchInfo: {
          ...state.playoff_matchInfo,
          tournaments: action.tournaments,
          matches: action.playoffMatches,
          tournamentMatches: action.tournamentMatches
        }
      };

    case rts.handleClear_playoffTeams: s
      _playoffInfo.playoffTeamCompares = []
      return { ...state, playoff_info: _playoffInfo }

    case rts.handleSelect_playoffTeam: {
      const { team } = action;
      const { playoffTeams, playoffLevelTeams } = _playoffInfo;
      const teams = playoffLevelTeams?.[state.playoffGroupKey];

      const matchesTeam = t =>
        (team._itemKey != null && t._itemKey === team._itemKey) ||
        (team.name != null && t.name === team.name);

      const _removeTeam = _.some(teams, matchesTeam);

      if (_removeTeam) {
        _.remove(playoffTeams, matchesTeam);
        if (teams) _.remove(teams, matchesTeam);
      } else {
        playoffTeams.push(team);

        if (teams) {
          const position = _.get(_.last(teams), 'position', -1) + 1;
          teams.push({
            ..._.omit(team, 'record'),
            position,
            seed: position + 1,
            owp: _.get(team, 'record.owp', 0).toFixed(2),
          });
        }
      }

      _playoffInfo.plts = createSportsHelpers.getPlayoffLevelTeamz(playoffLevelTeams);

      return { ...state, playoff_info: _playoffInfo };
    }

    case rts.handleSelectedTeams:
      const st = []
      if (teams && action.selected) {
        action.selected.forEach(si => {
          if (teams[si]) {
            st.push(teams[si])
          }
        })
      }
      const _tt = {
        selected: st,
      }
      return { ...state, teams: _tt }

    case rts.handleSet_team_playoffGroup:
      _playoffInfo.playoffLevelTeams[action.playoffGroupKey] = action.teams_playoffGroup
      return {
        ...state,
        playoffGroupKey: action.playoffGroupKey,
        playoff_info: _playoffInfo
      }

    case rts.handleSet_playoffLevelCount:
      if (!_playoffInfo.playoffLevelCounts) { _playoffInfo.playoffLevelCounts = {} }
      _playoffInfo.playoffLevelCounts[action.levelKey] = action.levelCount
      return { ...state, playoff_info: _playoffInfo }

    case rts.handleSet_playoffLevelTeams:
      const pltz = action.playoffLevelTeams
      _playoffInfo.playoffLevelTeams = action.playoffLevelTeams
      _playoffInfo.plts = createSportsHelpers.getPlayoffLevelTeamz(_playoffInfo.playoffLevelTeams)
      return { ...state, playoff_info: _playoffInfo }

    case rts.handleAmmend_playoffSeededTeams:
      createSportsHelpers.ammend_playoffSeedingMismatch(action.playoffLevelTeams, _playoffInfo)
      return {
        ...state,
        playoff_info: {
          ...state.playoff_info,
          playoffLevelTeams: action.playoffLevelTeams,
          playoffTeamsSorted: {
            ...state.playoff_info.playoffTeamsSorted,
            [state.playoffGroupKey]: true
          },
          plts: createSportsHelpers.getPlayoffLevelTeamz(action.playoffLevelTeams)
        }
      };

    case rts.handleUpdate_seededTeams:
      return { ...state, seededTeams: action.seededTeams }

    case rts.handleShow_playoffMatchLocation:
      return { ...state, showPlayoffMatchLocation: action.match }

    case rts.handleShow_playoffMatchTime:
      return { ...state, showPlayoffMatchTime: state.showPlayoffMatchTime ? null : action.match }

    case rts.handleAmmend_match:
      // updates the location of the selected playoff match
      const { match: m } = action
      if (_playoff_matchInfo && _playoff_matchInfo.matches) {
        convertHelpers.createItemKeys(_playoffInfo.matches)
        const _playoffMatch = _.find(_playoff_matchInfo.matches, { _itemKey: m._itemKey })
        if (_playoffMatch) {

          _playoff_matchInfo.matches[_playoffMatch._itemKey] = m

          const path_tournaments = ['tournaments', m.levels, 'rounds', m.roundKey, 'pools', m.poolKey, 'matches', `match${m.matchNumber}`];
          const nm_tournament = _.get(_playoff_matchInfo, path_tournaments);
          if (nm_tournament) { _.set(_playoff_matchInfo, path_tournaments, m); }

          const path_tournamentMatches = ['tournamentMatches', m?._itemKey];
          const nm_tournamentMatches = _.get(_playoff_matchInfo, path_tournamentMatches);
          if (nm_tournamentMatches) { _.set(_playoff_matchInfo, path_tournamentMatches, m); }
        }
      }
      return { ...state, playoff_matchInfo: _playoff_matchInfo, showPlayoffMatchLocation: null }

    case rts.handleAmmend_matchLocation:
      // updates the location of the selected playoff match
      if (_playoff_matchInfo && _playoff_matchInfo.matches) {
        convertHelpers.createItemKeys(_playoffInfo.matches)
        const _playoffMatch = _.find(_playoff_matchInfo.matches, { _itemKey: state.showPlayoffMatchLocation._itemKey })
        if (_playoffMatch) {
          _playoff_matchInfo.matches[_playoffMatch._itemKey].location = {
            id: action.team.id,
            name: action.team.name
          }
        }
      }
      return { ...state, playoff_matchInfo: _playoff_matchInfo, showPlayoffMatchLocation: null }

    case rts.handleAmmend_matchTime:
      if (_playoffInfo && _playoffInfo.matches) {
        convertHelpers.createItemKeys(_playoffInfo.matches)
        const _playoffMatch = _.find(_playoffInfo.matches, { _itemKey: state.showPlayoffMatchTime._itemKey })
        if (_playoffMatch) {
          _playoffInfo.matches[_playoffMatch._itemKey].startTime = action.startTime
        }
      }
      return { ...state, playoff_info: _playoffInfo, showPlayoffMatchTime: null }

    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation })

    default:
      return { ...state }
  }
}

export const createPlayoffHandlers = (dispatch) => {
  return {
    handleAmmend_level: (playoffLevel) => { dispatch({ type: rts.handleAmmend_level, dispatch, playoffLevel }) },
    handleAmmend_match: (match) => { dispatch({ type: rts.handleAmmend_match, dispatch, match }) },
    handleAmmend_matchLocation: (team) => { dispatch({ type: rts.handleAmmend_matchLocation, dispatch, team }) },
    handleAmmend_matchTime: (startTime) => { dispatch({ type: rts.handleAmmend_matchTime, dispatch, startTime }) },
    handleAmmend_playoffDateGroup: () => { dispatch({ type: rts.handleAmmend_playoffDateGroup, dispatch }) },
    handleAmmend_playoffMatchInfo: (tournaments, playoffMatches, tournamentMatches) => { dispatch({ type: rts.handleAmmend_playoffMatchInfo, dispatch, tournaments, playoffMatches, tournamentMatches }) },
    handleAmmend_playoffSeededTeams: (playoffLevelTeams) => { dispatch({ type: rts.handleAmmend_playoffSeededTeams, dispatch, playoffLevelTeams }) },
    handleClear_playoffTeams: () => { dispatch({ type: rts.handleClear_playoffTeams, dispatch }) },
    handleSelect_playoffDates: (playoffDateProps) => { dispatch({ type: rts.handleSelect_playoffDates, dispatch, playoffDateProps }) },

    handleSelect_playoffTeam: (team) => { dispatch({ type: rts.handleSelect_playoffTeam, dispatch, team }) },
    // handleSelect_playoffTeamRecord: (team) => { dispatch({ type: rts.handleSelect_playoffTeamRecord, dispatch, team }) },

    handleSelectedTeams: (selected) => { dispatch({ type: rts.handleSelectedTeams, dispatch, selected }) },
    handleSet_team_playoffGroup: (playoffGroupKey, teams_playoffGroup) => { dispatch({ type: rts.handleSet_team_playoffGroup, dispatch, playoffGroupKey, teams_playoffGroup }) },
    handleSet_playoffInfo: (playoff_info, fk) => { dispatch({ type: rts.handleSet_playoffInfo, dispatch, playoff_info, fk }) },
    handleSet_playoffLevelCount: (levelKey, levelCount) => { dispatch({ type: rts.handleSet_playoffLevelCount, dispatch, levelKey, levelCount }) },
    handleSet_playoffLevelTeams: (playoffLevelTeams) => { dispatch({ type: rts.handleSet_playoffLevelTeams, dispatch, playoffLevelTeams }) },
    handleShow_playoffMatchLocation: (match) => { dispatch({ type: rts.handleShow_playoffMatchLocation, dispatch, match }) },
    handleShow_playoffMatchTime: (match) => { dispatch({ type: rts.handleShow_playoffMatchTime, dispatch, match }) },
    handleUpdate_seededTeams: (seededTeams) => { dispatch({ type: rts.handleUpdate_seededTeams, dispatch, seededTeams }) },
    ...responseHandlers(dispatch),
  }
}

export const createPlayoffInitialState = (init_state) => {

  const { teams, pathViews } = init_state
  // const { sports } = pathViews

  const _teams = removeInactive(teams)

  const _playoffTeams = getTeams_playoffOnly(_teams)
  const _playoffLevelTeams = getPlayoffLevelTeamsInit(_teams)
  const _playoffDateInfo = createSportsHelpers.ammend_playoffDatesNeeded(_playoffLevelTeams)

  return {
    ...init_state, // (details_info)
    // currentSport: sports,
    playoff_info: {
      playoffTeams: _playoffTeams,
      playoffTeams_standings: teams,
      playoffLevelTeams: _playoffLevelTeams,
      playoffTeamsSorted: {},
      playoffTeamCompares: [],
      ..._playoffDateInfo
    },
    playoff_matchInfo: {},
    parentDataKeys: {}
  };
}

const removeInactive = (teams) => {
  _.forEach(teams, (team, teamKey) => {
    const mp = team?.record?.mp ?? 0
    if (mp === 0) {
      delete teams[teamKey]
    }
  })

  return teams
}

/**
 * 
 * @param {*} teams 
 * @returns team that are marked as a playoffTeam
 */
const getTeams_playoffOnly = (teams) => {
  const _teams = _.filter(teams, (t) => t.record && t.record.playoffTeam)
  return _teams
}

/**
 * 
 * @param {*} teams 
 * @returns playoff teams grouped into there level ('levels)
 */
const getPlayoffLevelTeamsInit = (teams) => {

  // Filter teams that are playoff teams
  const playoffTeams = _.filter(teams, (t) => t.record?.playoffTeam);

  // Group teams by levels
  const teamsByLevel = _.groupBy(playoffTeams, 'levels');

  // Transform grouped teams
  const playoffLevelTeams = _.mapValues(teamsByLevel, (teams) =>
    _.chain(teams)
      .map(({ record, ...team }) => ({
        ...team,
        swp: record?.swp,
        owp: record?.owp,
        ppm: record?.ppm,
        eloInfo: record?.eloInfo,
        rpiInfo: record?.rpiInfo,
        sectionRank: record?.sectionRank,
        display: record?.display,
        id: team._itemKey,
      }))
      .orderBy(['eloInfo.elo'], ['desc']) // Order by 'owp' descending
      .map((team, index) => ({
        ...team,
        seed: index + 1,
        position: index,
      }))
      .value()
  );

  return playoffLevelTeams;
}